import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/styles/ag-grid.min.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.min.css"; // Theme
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";

import "./style.css";

export default function GridV2(props) {
  const { columns, getOrderData, dataFetchKey = "" } = props;
  const gridRef = useRef();
  const orgRoles = useSelector((state) => state?.login?.orgDetails?.orgRoles);
  const [gridApi, setGridApi] = useState(null);

  // Column Definitions: Defines & controls grid columns.
  const colDefs = useMemo(() => columns.filter((column) => orgRoles?.includes("transfi_admin") || column.customerVisibility), [columns, orgRoles]);

  // Apply settings across all columns
  const defaultColDef = useMemo(
    () => ({
      filter: true, // Enable filtering on all columns
    }),
    [],
  );

  const quickFilterParser = useCallback((quickFilter) => {
    let quickFilterParts = [];
    let lastSpaceIndex = -1;
    const isQuote = (index) => quickFilter[index] === '"';
    const getQuickFilterPart = (lastSpaceIndex, currentIndex) => {
      const startsWithQuote = isQuote(lastSpaceIndex + 1);
      const endsWithQuote = isQuote(currentIndex - 1);
      const startIndex = startsWithQuote && endsWithQuote ? lastSpaceIndex + 2 : lastSpaceIndex + 1;
      const endIndex = startsWithQuote && endsWithQuote ? currentIndex - 1 : currentIndex;
      return quickFilter.slice(startIndex, endIndex);
    };
    for (let i = 0; i < quickFilter.length; i++) {
      const char = quickFilter[i];
      if (char === " ") {
        if (!isQuote(lastSpaceIndex + 1) || isQuote(i - 1)) {
          quickFilterParts.push(getQuickFilterPart(lastSpaceIndex, i));
          lastSpaceIndex = i;
        }
      }
    }
    if (lastSpaceIndex !== quickFilter.length - 1) {
      quickFilterParts.push(getQuickFilterPart(lastSpaceIndex, quickFilter.length));
    }
    return quickFilterParts;
  }, []);

  const onGridReady = (params) => {
    setGridApi(params.api);
    const datasource = {
      getRows: async (params) => {
        const { startRow, endRow, filterModel, sortModel, valueCols, pivotMode, pivotCols, groupKeys, rowGroupCols } = params.request;
        const filters = { startRow, endRow, filterModel, sortModel, valueCols, pivotMode, pivotCols, groupKeys, rowGroupCols };
        try {
          const response = await getOrderData(filters);
          const responseData = response.data.data;
          params.success({
            rowData: responseData.list,
            pivotResultFields: responseData.pivotFields,
          });
        } catch (error) {
          console.error(error);
          params.fail();
        }
      },
    };
    params.api.setServerSideDatasource(datasource);
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.refreshServerSide({ purge: true });
    }
  }, [dataFetchKey, gridApi]);

  return (
    <div className="ag-theme-quartz" style={{ height: 650 }}>
      <AgGridReact
        ref={gridRef}
        columnDefs={colDefs}
        defaultColDef={defaultColDef}
        pagination={true}
        onGridReady={onGridReady}
        rowModelType="serverSide"
        serverSideStoreType="partial"
        quickFilterParser={quickFilterParser}
        sideBar={{
          toolPanels: [
            {
              id: "columns",
              labelDefault: "Columns",
              labelKey: "columns",
              iconKey: "columns",
              toolPanel: "agColumnsToolPanel",
            },
          ],
          defaultToolPanel: "",
        }}
        suppressMenuHide={true}
        enableAdvancedFilter={true}
        suppressMultiRangeSelection={true}
        enableRangeSelection={true}
        rowGroupPanelShow={"always"}
        groupIncludeFooter={true}
        paginationPageSize={20}
        cacheBlockSize={20}
      />
    </div>
  );
}
